module.exports = __webpack_public_path__ + "static/media/main-md.254e0b65.svg";